export const departmentsAltLangModalLanguage = {
    en: {
        title: 'Alternative Display Language',
        ok: 'OK',
        cancel: 'Cancel',
        placeholder: 'Enter alternative name'
    },
    th: {
        title: 'ชื่อแสดงผลทางเลือก',
        ok: 'ตกลง',
        cancel: 'ยกเลิก',
        placeholder: 'ป้อนชื่อทางเลือก'
    },
    cn: {
        title: '替代显示语言',
        ok: '确定',
        cancel: '取消',
        placeholder: '输入替代名称'
    },
    jp: {
        title: '代替表示言語',
        ok: 'OK',
        cancel: 'キャンセル',
        placeholder: '代替名を入力してください'
    },
    kr: {
        title: '대체 표시 언어',
        ok: '확인',
        cancel: '취소',
        placeholder: '대체 이름 입력'
    }
}

export const departmentsAppearanceLanguage = {
    en: {
        NoImage: 'No Image',
        UploadImage: 'Upload Image',
        RemoveImage: 'Remove Image',
        ButtonColor: 'Button Color',
        ButtonFontSize: 'Button Font Size',
        XLarge: 'X-Large',
        Large: 'Large',
        Medium: 'Medium',
        Small: 'Small',
        Red: 'Red',
        Green: 'Green',
        Blue: 'Blue',
        Yellow: 'Yellow',
        Cyan: 'Cyan',
        Magenta: 'Magenta',
        Orange: 'Orange',
        Purple: 'Purple',
        Brown: 'Brown',
        Pink: 'Pink',
        Lime: 'Lime',
        Teal: 'Teal',
    },
    th: {
        NoImage: 'ไม่มีรูปภาพ',
        UploadImage: 'อัปโหลดรูปภาพ',
        RemoveImage: 'ลบรูปภาพ',
        ButtonColor: 'สีปุ่ม',
        ButtonFontSize: 'ขนาดตัวอักษรปุ่ม',
        XLarge: 'ขนาดใหญ่มาก',
        Large: 'ขนาดใหญ่',
        Medium: 'ขนาดกลาง',
        Small: 'ขนาดเล็ก',
        Red: 'แดง',
        Green: 'เขียว',
        Blue: 'น้ำเงิน',
        Yellow: 'เหลือง',
        Cyan: 'ฟ้า',
        Magenta: 'ม่วงแดง',
        Orange: 'ส้ม',
        Purple: 'ม่วง',
        Brown: 'น้ำตาล',
        Pink: 'ชมพู',
        Lime: 'เขียวอ่อน',
        Teal: 'เขียวอมฟ้า',
    },
    cn: {
        NoImage: '无图片',
        UploadImage: '上传图片',
        RemoveImage: '移除图片',
        ButtonColor: '按钮颜色',
        ButtonFontSize: '按钮字体大小',
        XLarge: '特大',
        Large: '大',
        Medium: '中',
        Small: '小',
        Red: '红色',
        Green: '绿色',
        Blue: '蓝色',
        Yellow: '黄色',
        Cyan: '青色',
        Magenta: '品红',
        Orange: '橙色',
        Purple: '紫色',
        Brown: '棕色',
        Pink: '粉色',
        Lime: '酸橙色',
        Teal: '蓝绿色',
    },
    kr: {
        NoImage: '이미지 없음',
        UploadImage: '이미지 업로드',
        RemoveImage: '이미지 제거',
        ButtonColor: '버튼 색상',
        ButtonFontSize: '버튼 글꼴 크기',
        XLarge: '특대',
        Large: '대',
        Medium: '중',
        Small: '소',
        Red: '빨강',
        Green: '초록',
        Blue: '파랑',
        Yellow: '노랑',
        Cyan: '청록',
        Magenta: '마젠타',
        Orange: '주황',
        Purple: '보라',
        Brown: '갈색',
        Pink: '분홍',
        Lime: '라임',
        Teal: '청록색',
    },
    jp: {
        NoImage: '画像なし',
        UploadImage: '画像をアップロード',
        RemoveImage: '画像を削除',
        ButtonColor: 'ボタンの色',
        ButtonFontSize: 'ボタンのフォントサイズ',
        XLarge: '特大',
        Large: '大',
        Medium: '中',
        Small: '小',
        Red: '赤',
        Green: '緑',
        Blue: '青',
        Yellow: '黄',
        Cyan: 'シアン',
        Magenta: 'マゼンタ',
        Orange: 'オレンジ',
        Purple: '紫',
        Brown: '茶色',
        Pink: 'ピンク',
        Lime: 'ライム',
        Teal: 'ティール',
    },
}

export const departmentsBasicLanguage = {
    en: {
        DepartmentNumber: 'Department Number',
        ShowOnMenu: 'Show on Menu',
        SaleDepartment: 'Sale Department',
        DepartmentName: 'Department Name',
        AlternativeDisplayLanguage: 'Alternative Display Language',
        Rate: 'Rate',
        TaxRate: 'Tax Rate',
        DisplayOrder: 'Display Order',
        Threshold: 'Threshold',
        NonDiscountable: 'Non-Discountable',
        NonSurchargeable: 'Non-Surchargeable',
        ScaleDepartment: 'Scale Department',
        UnitOfSale: 'Unit of Sale',
        Individually: 'Individually',
        Gram: 'Gram',
        Kilogram: 'Kilogram',
        Ounce: 'Ounce',
        Pound: 'Pound',
        Milliliter: 'Milliliter',
        Liter: 'Liter',
        Pint: 'Pint',
        Quart: 'Quart',
        Gallon: 'Gallon',
    },
    th: {
        DepartmentNumber: 'หมายเลขแผนก',
        ShowOnMenu: 'แสดงในเมนู',
        SaleDepartment: 'แผนกขาย',
        DepartmentName: 'ชื่อแผนก',
        AlternativeDisplayLanguage: 'ชื่อแสดงผลทางเลือก',
        Rate: 'อัตรา',
        TaxRate: 'อัตราภาษี',
        DisplayOrder: 'ลำดับการแสดงผล',
        Threshold: 'เกณฑ์',
        NonDiscountable: 'ไม่สามารถลดราคาได้',
        NonSurchargeable: 'ไม่สามารถคิดค่าบริการเพิ่มได้',
        ScaleDepartment: 'แผนกชั่งน้ำหนัก',
        UnitOfSale: 'หน่วยขาย',
        Individually: 'รายชิ้น',
        Gram: 'กรัม',
        Kilogram: 'กิโลกรัม',
        Ounce: 'ออนซ์',
        Pound: 'ปอนด์',
        Milliliter: 'มิลลิลิตร',
        Liter: 'ลิตร',
        Pint: 'ไพน์',
        Quart: 'ควอร์ต',
        Gallon: 'แกลลอน',
    },
    cn: {
        DepartmentNumber: '部门编号',
        ShowOnMenu: '在菜单中显示',
        SaleDepartment: '销售部门',
        DepartmentName: '部门名称',
        AlternativeDisplayLanguage: '替代显示语言',
        Rate: '税率',
        TaxRate: '税率',
        DisplayOrder: '显示顺序',
        Threshold: '阈值',
        NonDiscountable: '不可打折',
        NonSurchargeable: '不可加收费用',
        ScaleDepartment: '称重部门',
        UnitOfSale: '销售单位',
        Individually: '单个',
        Gram: '克',
        Kilogram: '千克',
        Ounce: '盎司',
        Pound: '磅',
        Milliliter: '毫升',
        Liter: '升',
        Pint: '品脱',
        Quart: '夸脱',
        Gallon: '加仑',
    },
    jp: {
        DepartmentNumber: '部門番号',
        ShowOnMenu: 'メニューに表示',
        SaleDepartment: '販売部門',
        DepartmentName: '部門名',
        AlternativeDisplayLanguage: '代替表示言語',
        Rate: '税率',
        TaxRate: '税率',
        DisplayOrder: '表示順',
        Threshold: 'しきい値',
        NonDiscountable: '割引不可',
        NonSurchargeable: '追加料金不可',
        ScaleDepartment: '計量部門',
        UnitOfSale: '販売単位',
        Individually: '個別',
        Gram: 'グラム',
        Kilogram: 'キログラム',
        Ounce: 'オンス',
        Pound: 'ポンド',
        Milliliter: 'ミリリットル',
        Liter: 'リットル',
        Pint: 'パイント',
        Quart: 'クォート',
        Gallon: 'ガロン',
    },
    kr: {
        DepartmentNumber: '부서 번호',
        ShowOnMenu: '메뉴에 표시',
        SaleDepartment: '판매 부서',
        DepartmentName: '부서 이름',
        AlternativeDisplayLanguage: '대체 표시 언어',
        Rate: '세율',
        TaxRate: '세율',
        DisplayOrder: '표시 순서',
        Threshold: '임계값',
        NonDiscountable: '할인 불가',
        NonSurchargeable: '추가 요금 불가',
        ScaleDepartment: '저울 부서',
        UnitOfSale: '판매 단위',
        Individually: '개별',
        Gram: '그램',
        Kilogram: '킬로그램',
        Ounce: '온스',
        Pound: '파운드',
        Milliliter: '밀리리터',
        Liter: '리터',
        Pint: '파인트',
        Quart: '쿼트',
        Gallon: '갤런',
    },
}

export const departmentsDetailsLanguage = {
    en: {
        Basic: 'Basic',
        Appearance: 'Appearance',
        ModifySave: 'Modify / Save',
        Delete: 'Delete',
        AreYouSure: 'Are you sure?',
        NotRevert: "You won't be able to revert this!",
        Confirm: 'Confirm',
        Deleted: 'Deleted!',
        DeletedMsg: 'Your file has been deleted.',
        Success: 'Success!',
        UpdateSuccess: 'Department details updated successfully',
        Cancel: 'Cancel',
    },
    th: {
        Basic: 'ข้อมูลพื้นฐาน',
        Appearance: 'ลักษณะ',
        ModifySave: 'แก้ไข / บันทึก',
        Delete: 'ลบ',
        AreYouSure: 'คุณแน่ใจหรือไม่?',
        NotRevert: 'คุณจะไม่สามารถย้อนกลับได้!',
        Confirm: 'ยืนยัน',
        Deleted: 'ลบแล้ว!',
        DeletedMsg: 'ไฟล์ของคุณถูกลบแล้ว',
        Success: 'สำเร็จ!',
        UpdateSuccess: 'อัปเดตรายละเอียดแผนกสำเร็จ',
        Cancel: 'ยกเลิก',
    },
    cn: {
        Basic: '基本信息',
        Appearance: '外观',
        ModifySave: '修改 / 保存',
        Delete: '删除',
        AreYouSure: '你确定吗？',
        NotRevert: '此操作无法撤销！',
        Confirm: '确认',
        Deleted: '已删除！',
        DeletedMsg: '您的文件已被删除。',
        Success: '成功！',
        UpdateSuccess: '部门详情更新成功',
        Cancel: '取消',
    },
    jp: {
        Basic: '基本情報',
        Appearance: '外観',
        ModifySave: '修正 / 保存',
        Delete: '削除',
        AreYouSure: 'よろしいですか？',
        NotRevert: 'この操作は元に戻せません！',
        Confirm: '確認',
        Deleted: '削除されました！',
        DeletedMsg: 'ファイルが削除されました。',
        Success: '成功！',
        UpdateSuccess: '部門詳細が正常に更新されました',
        Cancel: 'キャンセル',
    },
    kr: {
        Basic: '기본 정보',
        Appearance: '외관',
        ModifySave: '수정 / 저장',
        Delete: '삭제',
        AreYouSure: '확실합니까?',
        NotRevert: '이 작업은 되돌릴 수 없습니다!',
        Confirm: '확인',
        Deleted: '삭제됨!',
        DeletedMsg: '파일이 삭제되었습니다.',
        Success: '성공!',
        UpdateSuccess: '부서 세부정보가 성공적으로 업데이트되었습니다',
        Cancel: '취소',
    },
}

export const departmentsListLanguage = {
    en: {
        Add: 'Add',
        Departments: 'Departments',
    },
    th: {
        Add: 'เพิ่ม',
        Departments: 'แผนก',
    },
    cn: {
        Add: '添加',
        Departments: '部门',
    },
    jp: {
        Add: '追加',
        Departments: '部門',
    },
    kr: {
        Add: '추가',
        Departments: '부서',
    },
}

export const departmentsModalLanguage = {
    en: {
        NewDepartment: 'New Department',
        DepartmentNumber: 'Department Number',
        DepartmentNumberPlaceholder: 'Department Number',
        DepartmentName: 'Department Name',
        DepartmentNamePlaceholder: 'Department Name',
        OK: 'OK',
        Cancel: 'Cancel',
    },
    th: {
        NewDepartment: 'แผนกใหม่',
        DepartmentNumber: 'หมายเลขแผนก',
        DepartmentNumberPlaceholder: 'หมายเลขแผนก',
        DepartmentName: 'ชื่อแผนก',
        DepartmentNamePlaceholder: 'ชื่อแผนก',
        OK: 'ตกลง',
        Cancel: 'ยกเลิก',
    },
    cn: {
        NewDepartment: '新部门',
        DepartmentNumber: '部门编号',
        DepartmentNumberPlaceholder: '部门编号',
        DepartmentName: '部门名称',
        DepartmentNamePlaceholder: '部门名称',
        OK: '确定',
        Cancel: '取消',
    },
    jp: {
        NewDepartment: '新しい部門',
        DepartmentNumber: '部門番号',
        DepartmentNumberPlaceholder: '部門番号',
        DepartmentName: '部門名',
        DepartmentNamePlaceholder: '部門名',
        OK: 'OK',
        Cancel: 'キャンセル',
    },
    kr: {
        NewDepartment: '새 부서',
        DepartmentNumber: '부서 번호',
        DepartmentNumberPlaceholder: '부서 번호',
        DepartmentName: '부서 이름',
        DepartmentNamePlaceholder: '부서 이름',
        OK: '확인',
        Cancel: '취소',
    },
}